import { useFormContext } from '../../Context';
import EditableInput from 'Components/Weaver/Input/EditableInput'
import { Form } from 'antd'

const Config = ({ form, ...props }) => {

  const { formValues, updateFormValues } = useFormContext();

  const initialValues = formValues?.config || {};
  const properties = formValues.header?.functionality?.configDefinition?.properties || {}
  const relevantProperties = Object.entries(properties).filter(([key, configProps]) => !(key === 'file'))

  return (
    <div className="task-form">
      <Form
        form={form}
        initialValues={initialValues}
        onValuesChange={(vals) => {
          const updatedConfig = { ...form.getFieldsValue(), ...vals }
          updateFormValues({ config: updatedConfig })
        }}
      >
        {
          Object.keys(properties).length !== 0 ?
            relevantProperties.map(([key, configProps]) => {
              return (
                <Form.Item
                  label={_.startCase(key)}
                  name={key}
                  key={key}
                >
                  <EditableInput {...configProps} />
                </Form.Item>
              )
            })
            :
            <div className="empty">
              <h3>Please select a functionality from the Header form.</h3>
            </div>
        }
      </Form>
    </div>
  )
}

export default Config;
